"use strict";
// SPDX-FileCopyrightText: 2024 Red Bee Media Ltd <https://www.redbeemedia.com/>
//
// SPDX-License-Identifier: MIT
Object.defineProperty(exports, "__esModule", { value: true });
exports.EngineEvents = void 0;
const media_event_filter_1 = require("@eyevinn/media-event-filter");
const js_player_shared_1 = require("@ericssonbroadcastservices/js-player-shared");
const CustomEngineEvents = {
    VOLUME_CHANGE: "volumechange",
    ERROR: "error",
    DROPPED_FRAMES: "dropped_frames",
    BITRATE_CHANGED: "bitrate_changed",
    AUDIO_CHANGED: "audio_changed",
    SUBTITLE_CHANGED: "subtitle_changed",
    SUBTITLE_CUE_CHANGED: "subtitle_cue_changed",
    TRACKS_CHANGED: "tracks_changed",
    DRM_UPDATE: "drm:update",
    STATE_CHANGED: "state_changed",
    METADATA_EVENT: "metadata_event",
    PLAYBACK_RATE_CHANGED: "playback_rate_changed",
};
exports.EngineEvents = Object.assign(Object.assign({}, media_event_filter_1.FilteredMediaEvent), CustomEngineEvents);
//# sourceMappingURL=interfaces.js.map